<template>
  <div class="field-input" :class="{ 'has-error': $validator.errors.has(name) }">
    <el-input v-model="internalValue" :disabled="disabled === false" :placeholder="placeholder" :name="name"
              v-validate="validate" data-vv-value-path="internalValue" :data-vv-as="validateLabel"></el-input>
    <span class="annotation">※複数指定する場合は「,」で区切って入力してください（例）除,外,単語</span>
    <span class="error-message"><strong>{{$validator.errors.first(name)}}</strong></span>
  </div>
</template>

<script lang="js">
export default {
  name: 'StopWordsCmp',
  components: {},
  props: {
    value: null,
    name: '',
    placeholder: null,
    validate: null,
    validateLabel: '',
    disabled: ''
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  data () {
    return {
      internalValue: this.value
    }
  },
  watch: {
    value (newValue) {
      this.internalValue = newValue
    },
    internalValue (newValue) {
      this.$emit('input', newValue)
    }
  }
}

</script>
<style scoped>
  .field-input {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .annotation {
    font-size: 0.75rem;
    color: #999;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/field/hyper-param/stop-words.vue